import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import React, {  Suspense } from "react";
// import { metaDetails } from "./Reducer/metaReducer";
// import "bootstrap/dist/css/bootstrap.min.css";
import Header from "./components/Header/Header";
import MainRequest from "./Helper/mainRequest";
import Home from "./components/Front/Home"
// import Repairs from "./components/pages/Repairs";
// import Single_product from "./components/product/single_product/ProductDetail";
import Skeleton from "react-loading-skeleton";
import { Repairs } from "./components/pages/Repairs";
const Footer = React.lazy(() => import("./components/Footer/Footer"));
// const Home = React.lazy(() => import("./components/Front/Home"));
const Single_product = React.lazy(() => import("./components/product/single_product/ProductDetail"));
const Product_list = React.lazy(() => import("./components/product/product_list"));
const Termscondition = React.lazy(() => import("./components/pages/Termscondition"));
const Privacypolicy = React.lazy(() => import("./components/pages/Privacypolicy"));
const Contactus = React.lazy(() => import("./components/pages/Contact"));
const CustomerService = React.lazy(() => import("./components/pages/CustomerService"));
// const MainRequest = React.lazy(() => import("./Helper/mainRequest"));
const Stay_tuned = React.lazy(() => import("./components/pages/Stay_tuned"));
const Cart = React.lazy(() => import("./components/pages/Shoping/Cart"));
const Checkout = React.lazy(() => import("./components/pages/Shoping/Checkout"));
const ThankU = React.lazy(() => import("./components/pages/Shoping/ThankU"));
const Login = React.lazy(() => import("./components/pages/Login"));
const ShowRoom = React.lazy(() => import("./components/pages/showroom"));
const Wishlist = React.lazy(() => import("./components/pages/Shoping/Wishlist"));
const SchedulePage = React.lazy(() => import("./components/pages/schedule"));
const Gallery = React.lazy(() => import("./components/pages/customdesing/Gallery"));
const Education = React.lazy(() => import("./components/pages/Education"));
const Customdesign = React.lazy(() => import("./components/pages/customdesing/Customdesign"));
const InPersonConsultation = React.lazy(() => import("./components/pages/InPersonConsultation"));
const InVirtualConsultation = React.lazy(() => import("./components/pages/InVirtualConsultation"));
const FreeCustomDesign = React.lazy(() => import("./components/pages/customdesing/InFreeCustomDesign"));
const OurTeam = React.lazy(() => import("./components/pages/OurTeam"));
const OurDifference = React.lazy(() => import("./components/pages/OurDifference"));
// const {Repairs} = React.lazy(() => import("./components/pages/Repairs"));
// const {Repairs} = React.lazy(() => import("./components/pages/Repairs"));
const SellGoldSilverJewelry = React.lazy(() => import("./components/pages/SellGoldSilverJewelry"));
const Verify = React.lazy(() => import("./components/pages/Verify"));
const JewelryGuides = React.lazy(() => import("./components/pages/JewelryGuides"));
const Engagement_rings_buying_guide = React.lazy(() => import("./components/pages/engagement_rings_buying_guide"));
const Fashion_Jewelry_guide = React.lazy(() => import("./components/pages/Fashion_Jewelry_guide"));
const Lab_Grown_diamond_jewelry_guide = React.lazy(() => import("./components/pages/Lab_Grown_diamond_jewelry_guide"));
const RingPromise = React.lazy(() => import("./components/pages/RingPromise"));
const FashionRingGuide = React.lazy(() => import("./components/pages/FashionRingGuide"));
// const FallBandEvent = React.lazy(() => import("./components/pages/FallBandEvent"));
const NeckalceAndPandentGuide = React.lazy(() => import("./components/pages/NeckalceAndPandentGuide"));
const UltimateBraceletGuide = React.lazy(() => import("./components/pages/UltimateBraceletGuide"));
const UltimateGuideOfWeddingBand = React.lazy(() => import("./components/pages/UltimateGuideOfWeddingBand"));
const EarringGuide = React.lazy(() => import("./components/pages/EarringGuide"));
const GabrielCo = React.lazy(() => import("./components/pages/GabrielCo"));
const OrderHistory = React.lazy(() => import("./components/pages/OrderHistory"));
const AccountAssistance = React.lazy(() => import("./components/pages/AccountAssistance"));
const AccountAssistanceWithoutEmail = React.lazy(() => import("./components/pages/AccountAssistanceWithoutEmail"));
const PasswordReset = React.lazy(() => import("./components/pages/PasswordReset"));
const PasswordResetComplete = React.lazy(() => import("./components/pages/PasswordResetCompelete"));
const SettingsPage = React.lazy(() => import("./components/pages/Settings"));
const Redirection = React.lazy(() => import("./components/Redirect/Redirect"));
const OfferList = React.lazy(() => import("./components/product/offerList"));
const BandEvent = React.lazy(() => import("./components/pages/spring-band-events"));
const Blog = React.lazy(() => import("./components/pages/blogs"));
const BlogDetails = React.lazy(() => import("./components/pages/blogs/BlogDetails"));
const Error = React.lazy(() => import("./components/pages/Shoping/Error"));
const WishlistAccountPage = React.lazy(() => import("./components/pages/WishlistAccountPage"));
const SummerBandEvent = React.lazy(() => import("./components/pages/SummerBandEvent"));
const ShowRooms = React.lazy(() => import("./components/pages/showroom/index"));
const FinanceCalculator = React.lazy(() => import("./components/pages/FinanceCalculator"));
const CustomProductDetail = React.lazy(() => import("./components/product/single_product/customProductDetail"));
const BlogCategory = React.lazy(() => import("./components/pages/blogs/BlogCategory"));
const Skelton = () => {
  return (
    <>
      <div className="sk" style={{ margin: "15px 0px" }} >
        <Skeleton variant="text" animation="wave" height={40}/>
      </div>
    </>
  );
};
function App() {

  return (
    <>      
      <BrowserRouter>
      <MainRequest />
        <Header />
        <div className="mainPage">
          <Routes>
          <Route path="/repairs" element={<Repairs />} />
          <Route index element={<Home />} />
          </Routes>
        <Suspense fallback={
                <>
                  <Skelton />
                </>
              }>
        <Routes>
        
          {/* DYNAMIC PAGES */}
          <Route
            path="/product-detail/:group_id/:slug/:stone_quality"
            element={<Single_product />}
            exact
          />
            <Route
            path="/custom-product-detail/:group_id/:slug/:stone_quality"
            element={<CustomProductDetail />}
            exact
          />
                  <Route
            path="/custom-product-detail/:group_id/:slug"
            element={<CustomProductDetail />}
            exact
          />
          <Route
            path="/product-detail/:group_id/:slug"
            element={<Single_product />}
            // exact
          />
          <Route
            path="/productlist/:category/:filterslug/:filterslug2"
            element={<Product_list />}
          />
          <Route
            path="/productlist/:category/:filterslug"
            element={<Product_list />}
          />
           {/* <Route
            path="/productlist/fine-jewelry/emerald-gemstone"
            element={<Product_list />}
          /> */}
          <Route path="/productlist/:category" element={<Product_list />} />
          <Route path="/special" element={<OfferList />} />
          <Route path="/special/:category" element={<OfferList />} />
          <Route path="/searchlist/:search" element={<Product_list />} />
          <Route
            path="/customer-service/:pageType"
            element={<CustomerService />}
          />
          <Route
            path="/thank-you/:order_number/:order_id"
            element={<ThankU />}
          />
          <Route
            path="/person-appointment/:location"
            element={<InPersonConsultation />}
          />
          <Route path="/cart" element={<Cart popup={false} />} />
          <Route path="/checkout" element={<Checkout />} />
          {/* STATIC PAGES */}
          <Route path="/terms-and-conditions" element={<Termscondition />} />
          <Route path="/privacy-policy" element={<Privacypolicy />} />
          <Route path="/contact-us" element={<Contactus />} />
          <Route path="/customer-service" element={<CustomerService />} />
          {/* <Route path="/services/financing" element={<Financing />} /> */}
          <Route path="/stay-tuned" element={<Stay_tuned />} />
          {/* <Route path="/wedding-band-event" element={<EventAppointment/>} /> */}
          <Route path="/fall-band-event" element={<SummerBandEvent />} />
          <Route path="/login" element={<Login />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/book-an-appointment" element={<SchedulePage />} />
          <Route path="/showroom" element={<ShowRoom />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/wishlist" element={<Wishlist popup={false} />} />
          <Route path="/education" element={<Education />} />
          <Route path="/custom-design" element={<Customdesign />} />
          <Route
            path="/person-appointment"
            element={<InPersonConsultation />}
          />
          <Route
            path="/virtual-appointment"
            element={<InVirtualConsultation />}
          />
          <Route path="/free-custom-design" element={<FreeCustomDesign />} />
          <Route path="/our-team" element={<OurTeam />} />
          <Route path="/our-difference" element={<OurDifference />} />
          <Route
            path="/sell-gold-silver-jewelry"
            element={<SellGoldSilverJewelry />}
          />
          <Route path="/jewelry-guides" element={<JewelryGuides />} />
          <Route
            path="/engagement-rings-buying-guide"
            element={<Engagement_rings_buying_guide />}
          />
          <Route
            path="/fashion-Jewelry-guide"
            element={<Fashion_Jewelry_guide />}
          />
          <Route
            path="/lab-Grown-diamond-jewelry-guide"
            element={<Lab_Grown_diamond_jewelry_guide />}
          />
          <Route
            path="/necklaces-and-pendants-guide"
            element={<NeckalceAndPandentGuide />}
          />
          <Route
            path="/ultimate-bracelet-guide"
            element={<UltimateBraceletGuide />}
          />
          <Route
            path="/the-ultimate-guide-to-wedding-bands"
            element={<UltimateGuideOfWeddingBand />}
          />
          <Route path="/earring-guide" element={<EarringGuide />} />
          <Route path="/fashion-ring-guide" element={<FashionRingGuide />} />
          <Route path="/gabriel-co" element={<GabrielCo />} />
          <Route path="/ring-promise" element={<RingPromise />} />
          {/* <Route path="/fall-band-event" element={<FallBandEvent />} /> */}
          <Route path="/user/verify" element={<Verify />} />
          <Route path="/order-history" element={<OrderHistory />} />
          <Route path="/account-assistance" element={<AccountAssistance />} />
          <Route
            path="/account-assistance-2"
            element={<AccountAssistanceWithoutEmail />}
          />
          <Route path="/reset-password" element={<PasswordReset />} />
          <Route
            path="/reset-password-complete"
            element={<PasswordResetComplete />}
          />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/wishlists" element={<WishlistAccountPage />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/category/:subcategory" element={<BlogCategory />} />
          <Route path="/blog/:slug" element={<BlogDetails />} />
          <Route path="/spring-band-event" element={<BandEvent />} />
          <Route path="/payment-declined" element={<Error />} />
          <Route path="/showroom/:slug" element={<ShowRooms />} />
          <Route path="/financing" element={<FinanceCalculator />} />

          <Route path="*" element={<Redirection />} />
          {/* <Route path='*' element={<Stay_tuned />} />*/}
        </Routes>
        </Suspense>
        </div>
        <Suspense
              fallback={
                <>
                  <Skelton />
                </>
              }
            >
              
        <Footer />
            </Suspense>
      </BrowserRouter>
    </>
  );
}

export default App;
